import {
  actionCard, openModal, tablePageController, translate,
} from 'magner';
import residentsTable from 'features/residents/table/hubstr';
import residentsFilters from 'features/residents/filters/hubstr';
import { Resident } from 'features/residents/types/hubstr';
import { residentRead } from 'features/residents/requests/hubstr';
import MembersImportDialog from 'features/residents/residents/membersImportDialog.vue';
import { isMembersImportAvailable } from 'features/residents/utils/members-import-access';

const residentsConfig = tablePageController<Resident>({
  header: {
    title: translate('hubstr.resident.table.title'),
    actions: [
      {
        type: 'action',
        props: {
          type: 'default' as any,
          text: translate('hubstr.resident.members_import.button'),
          // Magner не умеет скрывать кнопки шапки, поэтому скрываем классом.
          // Геттер читает реактивный appStore и пересчитывается при рендере.
          get class () {
            return isMembersImportAvailable() ? '' : 'members-import-hidden';
          },
        },
        emits: 'update-table',
        action: actionCard<any>(async () => {
          if (import.meta.env.DEV) {
            console.info('[MembersImport.button] open dialog');
          }
          try {
            await openModal<any>({
              type: 'custom',
              handleBeforeClose: false,
              customClass: 'modal-max-width modal-max-width__800',
              component: () => MembersImportDialog,
              props: {},
            });
            return false;
          } catch (e) {
            if (e !== null) {
              console.error('[MembersImport.button] modal failed', e);
              return translate('hubstr.resident.members_import.error');
            }
            return false;
          }
        }),
      },
      {
        type: 'link',
        to: { name: 'resident', params: { id: 'new' } },
        props: {
          type: 'primary',
          text: translate('hubstr.resident.filters.create_new'),
        },
      },
    ],
  },
  request: residentRead,
  table: residentsTable as any,
  filters: residentsFilters,
});

export default residentsConfig;
